import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96a6f4e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row codes-search-bar q-pa-md q-gutter-md" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CodesSearchBar',
  setup(__props) {

const model = ref(null);
const text = ref('');

let options = [
  'Diagnosis, ICD-CM',
  'External Cause, ICD-10-CM',
  'Procedure, ICD-10-PCS',
];

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_select, {
        outlined: "",
        dense: "",
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        options: _unref(options),
        label: "Book",
        class: "book"
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_input, {
        dense: "",
        outlined: "",
        modelValue: text.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((text).value = $event)),
        label: "Search for a term or code..."
      }, {
        append: _withCtx(() => [
          (text.value === '')
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: "search"
              }))
            : (_openBlock(), _createBlock(_component_q_icon, {
                key: 1,
                name: "clear",
                class: "cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (text.value = ''))
              }))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})